import type { AuthContextType } from '@context/auth.context';
import type { TelegramGroup } from '@interfaces/telegram-group';
import { apiRequest, isResponse } from '@services/fetcher';
import type { OffsetPaginatedResponse } from '@utils/api/api-response';

async function fetchConversations(
  auth: AuthContextType,
  query: string | null = null,
  page: number | null = 1,
  pageSize: number | null = 10,
  options?: RequestInit,
) {
  let url = `${import.meta.env.VITE_API_URL}/manage/telegram-group?page=${page}&limit=${pageSize}`;
  if (query) {
    url = `${url}&${query}`;
  }
  const response = await apiRequest<OffsetPaginatedResponse<TelegramGroup>>(url, auth, options);

  if (isResponse(response)) {
    return {
      status: response.status,
      statusText: response.statusText,
    } as Response;
  }

  if (response instanceof Error) {
    throw response;
  }

  return response;
}

export default fetchConversations;
